










import Vue from "vue";
require("lightslider")

export default Vue.extend({
	name: "Slider",
	data() {
		return <{
			slider: null | {
				goToSlide: (number: number) => void;
				goToPrevSlide: () => void;
				goToNextSlide: () => void;
				getCurrentSlideCount: () => void;
				refresh: () => void;
				play: () => void;
				pause: () => void;
				destroy: () => void;
			}
		}>{
			slider: null
		};
	},
	mounted(): void {
		this.initializedSlider();
	},
	destroyed(): void {
		if (this.slider == null) return;
		this.slider.destroy();
	},
	methods: {
		initializedSlider(numberOfCalls = 1) {
			console.debug("Attempting to initialize slider, waiting for correct height", numberOfCalls);

			if(this.$refs.sliderWrapper) {
				const height = (<any>this.$refs.sliderWrapper).clientHeight;
				if(height > 40) {
					console.debug("Slider height is correct, starting slider");
					this.slider = $(this.$refs.slider).lightSlider({
						item: 1,
						loop: true,
						adaptiveHeight: true,
						controls: false
					});
					return;
				}
			}

			if(numberOfCalls >= 10) {
				throw new Error(`Unable to initialize slider, tried ${numberOfCalls} times`);
			}

			setTimeout(() => {
				this.initializedSlider(numberOfCalls + 1);
			}, 50);
		}
	}
});
